// extracted by mini-css-extract-plugin
module.exports = {"aeroexpress":"aeroexpress-3H7ro","header":"header-MK0Nm","list__cities":"list__cities-3YaBl","aeroexpress_aggregator":"aeroexpress_aggregator-2cYX9"};